(() => {
  if (customElements.get('image-carousel')) {
    return;
  }

  class ImageCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderOptions = {};
      this.indicatorElements = this.querySelectorAll('.js-indicator');
      this.gap = this.dataset.gap;
      this.slides = this.dataset.slides;

      this.sliderPrev = this.querySelector('.swiper-arrow--prev');
      this.sliderNext = this.querySelector('.swiper-arrow--next');
      this.play = this.querySelector('.swiper-play-button');
      this.autoplayEnabled = this.querySelector('[data-slider]').dataset.autoplay === 'true';
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      const slides = this.slides.split('@');

      let mobileSlides = 1.5;
      let tabletPSlides = 2.5;
      let tabletLSlides = 3.5;
      let desktopSlides = 4.7;

      slides.forEach((slide, index) => {
        if (index == 0) {
          mobileSlides = Number(slide);
        }

        if (index == 1) {
          tabletPSlides = Number(slide);
        }

        if (index == 2) {
          tabletLSlides = Number(slide);
        }

        if (index == 3) {
          desktopSlides = Number(slide);
        }
      });

      this.sliderOptions = {
        autoplay: {
          delay: 0, // Set the autoplay delay in milliseconds
          disableOnInteraction: false,
        },
        speed: 300,
        slidesPerView: mobileSlides,
        centeredSlides: true,
        spaceBetween: Number(this.gap),
        loop: true,
        on: {
          slideChange: () => {
            this.handleSlideChange();
          },
        },
        breakpoints: {
          750: {
            centeredSlides: false,
            slidesPerView: tabletPSlides,
          },
          990: {
            centeredSlides: false,
            slidesPerView: tabletLSlides,
          },
          1200: {
            centeredSlides: false,
            slidesPerView: desktopSlides,
          },
        },
        navigation: {
          prevEl: this.sliderPrev,
          nextEl: this.sliderNext,
        },
      };

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);
      this.slider.autoplay.stop();

      this.handleSlideChange();
      this.autoplay()
    }

    autoplay() {
      if (this.play != null) {
        this.play.addEventListener('click', ()=> {
          if (this.slider.autoplay.running) {
            // If autoplay is running, stop it and change the button text
            this.slider.autoplay.stop();
            this.slider.params.speed = 300;

            this.play.classList.add('stopped')
          } else {
            // If autoplay is not running, start it and change the button text
            this.slider.params.speed = 3000;
            this.slider.autoplay.start();
            this.play.classList.remove('stopped')
          }
        });
      };

      if (this.autoplayEnabled) {
        this.slider.params.speed = 3000;
        this.slider.autoplay.start();
      };

      window.addEventListener('resize', (event)=> {
        this.slider.autoplay.stop();

        setTimeout(() => {
          if (this.play && !this.play.classList.contains('stopped')) {
            this.slider.params.speed = 3000;
            this.slider.autoplay.start();
          };

          if (this.autoplayEnabled) {
            this.slider.params.speed = 3000;
            this.slider.autoplay.start();
            console.log('end')
          };
        }, 10);
      });
    }

    handleSlideChange() {
      if (this.slider != null) {
        var currentSlideIndex = this.slider.realIndex + 1;
        var totalSlides = this.slider.slides.length;

        this.indicatorElements.forEach((indicatorElement) => {
          indicatorElement.textContent = currentSlideIndex + '/' + totalSlides;
        });
      };
    }
  }

  customElements.define('image-carousel', ImageCarousel);
})();
